import React from 'react';

export const ErrorIcon = props => {
  return (
    <span className="solstice-icon- solstice-icon-error" style={props.style} />
  );
};
